import Layout from "components/common/Layout";

function withLayout(WrapperComponent) {
  return (props) => (
    <Layout>
      <WrapperComponent {...props} />
    </Layout>
  );
}

export default withLayout;
